import { render } from "./Guess.vue?vue&type=template&id=31ac8218&scoped=true"
import script from "./Guess.vue?vue&type=script&lang=js"
export * from "./Guess.vue?vue&type=script&lang=js"

import "./Guess.vue?vue&type=style&index=0&id=31ac8218&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ac8218"]])

export default __exports__